import { requestWithToken as request } from "./api";

export const sendEmail = (data) =>
    request.post("/export_documents/send_n8n_email/?format=json", data);
